<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-import-file"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title style="padding-left: 35px;"
        >Importing Price Updates</md-dialog-title
      >

      <div class="dialog-content">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-100"
            style="padding-left: 5px; font-weight: bold; font-size: 14px;"
          >
            List File Import:
          </div>

          <!-- TABLE -->
          <div class="md-layout-item md-size-100 table-import-file">
            <!-- HEAD -->
            <div class="divHeadList">
              <div style="width: 60%;" class="-font-kanit">ชื่อ</div>
              <div style="width: 35%;" class="-font-kanit">แก้ไขล่าสุด</div>
              <div style="width: 5%;"></div>
            </div>

            <!-- BODY -->
            <div class="divBodyList">
              <div
                v-show="tableImportFile.length === 0"
                :class="'row-bg-gray'"
                style="display: block; text-align: center; font-size: 14px;"
              >
                No data in table.
              </div>

              <div
                :class="
                  fileID == file.id ? 'row-bg-blue -file' : 'row-bg-gray -file'
                "
                v-for="(file, fileIndex) in tableImportFile"
                :key="fileIndex"
              >
                <div style="width: 60%;" v-on:click="selectFile(file.id)">
                  <i
                    class="md-icon material-icons"
                    style="font-size: 20px !important; padding-top: 2px;"
                    >attach_file</i
                  >
                  {{ file.name }}
                </div>
                <div style="width: 35%;" v-on:click="selectFile(file.id)">
                  {{ formatDate(file.modifiedTime) }}
                </div>
                <div style="width: 5%;">
                  <i
                    title="Delete"
                    class="md-icon material-icons -delete"
                    style="color: #b3b3b3;"
                    v-on:click="deleteFile(file)"
                    >delete_sweep</i
                  >
                </div>
              </div>
            </div>

            <!-- FOOTER -->
            <!-- <div class="footer-table">
              number of lines in page ({{ tableImportFile.length }})
            </div> -->
          </div>
        </div>
      </div>

      <md-dialog-actions style="padding: 10px 17px;">
        <div class="md-layout-item md-size-20"></div>
        <div
          class="md-layout-item md-size-60"
          style="text-align: center; font-style: italic;"
        >
          number of lines in page ({{ tableImportFile.length }})
        </div>
        <div class="md-layout-item md-size-20">
          <md-button class="-cancel" @click="onClickCancel()">CANCEL</md-button>
          <md-button class="-confirm" @click="onClickConfirm()"
            >CONFIRM</md-button
          >
        </div>
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :title="titleDialog"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ contentSnackbar }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
import DialogConfirm from "./../../shared/dialog-confirm";
import BookpriceService from "@/services/bookprice";
import moment from "moment-timezone";

export default {
  name: "dialog-import-file",

  components: {
    DialogConfirm
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.tableImportFile = this.data;
      }
    }
  },

  data() {
    return {
      checkEvent: "",
      showDialogConfirm: false,
      titleDialog: "",
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      tableImportFile: [],
      fileID: "",
      fileIdDelete: "",
      fileNameDelete: "",
      showSnackbar: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      contentSnackbar: ""
    };
  },

  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    selectFile(id) {
      this.fileID = id;
    },
    deleteFile(files) {
      this.checkEvent = "delete";
      this.fileIdDelete = files.id;
      this.fileNameDelete = files.name;
      this.titleDialog = "Delete File";
      this.contentDialog =
        "Are you sure you want to delete " + this.fileNameDelete + " ?";
      this.cancelText = "NO";
      this.confirmText = "YES";
      this.showDialogConfirm = true;
    },
    fileDelete() {
      this.checkBackdrop = false;

      this.loading = true;
      BookpriceService.deleteFilePriceList(this.fileIdDelete).then(response => {
        this.loading = false;
        if (!response.status) {
          this.contentSnackbar = "Delete file unsuccessfully. " + response.msg;
          this.showSnackbar = true;
        } else {
          let index = this.tableImportFile
            .map(function(e) {
              return e.id;
            })
            .indexOf(this.fileIdDelete);
          if (index > -1) {
            this.tableImportFile.splice(index, 1);
          }

          this.contentSnackbar =
            "Delete file '" + this.fileNameDelete + "' successfully.";
          this.showSnackbar = true;
        }
      });
    },
    onClickCancel() {
      this.checkEvent = "cancel";
      this.titleDialog = "";
      this.cancelText = "CANCEL";
      this.confirmText = "OK";
      this.contentDialog = "Are you sure you want to add and close ?";
      this.showDialogConfirm = true;
    },
    onClickConfirm() {
      if (this.fileID == "") {
        this.contentSnackbar = "Please select file.";
        this.showSnackbar = true;
        return false;
      }

      this.checkEvent = "confirm";
      this.titleDialog = "";
      this.cancelText = "CANCEL";
      this.confirmText = "OK";
      this.contentDialog = "Are you sure you want to confirm ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.fileID = "";
        this.$emit("cancel");
      } else if (this.checkEvent === "confirm") {
        this.$emit("confirm", this.fileID);
        this.fileID = "";
      } else if (this.checkEvent === "delete") {
        this.fileDelete();
      }
      this.showDialogConfirm = false;
    }
  }
};
</script>

<style lang="scss">
.bookprice-dialog-import-file {
  width: 70%;
  height: 60%;
  transform: unset !important;
  top: 20% !important;
  left: 17% !important;
  font-weight: 400 !important;

  .table-import-file {
    padding: 0;

    .divBodyList {
      height: calc(60vmin - 205px);

      .row-bg-gray:hover {
        &.-file {
          cursor: pointer;
        }
      }

      .row-bg-blue {
        border-radius: 4px;
        background: #e8f0fe;
        color: #005fd0;

        .-delete {
          color: #005fd0 !important;
        }
      }
    }
  }
}
</style>